// @ vendors 
const React = require('react');
const PropTypes = require('prop-types');
const {  formatText } = require('core/i18n').i18n;
const { connect } = require('react-redux');

// @constants
const {
    recordPath,
    PROC_FAIL
} = require('utilities/tagging');
const {
    BENEFICIARY_TYPE_NGO,    
} = require('constants/index');

// @components
const WizardError = require('components/commons/wizardError/wizardError');
// helpers
const { getServiceTypeValue } = require('../../components/transfersSteps/transferSteps/analytics/transferStepsAnalytics');


require('./transferView.scss');

class TransferViewErrors extends React.Component {

    constructor(props) {
        super(props);
    }

    render () {
        const { immTransferState, errorMessage } = this.props;
        const beneficiaryType = immTransferState.getIn(['steps', 0, 'beneficiary', 'type']);
        const errorTitle = formatText('mytransfers-errorTitle');
        const goBackButton = {
            label: formatText('mytransfers-errorBackToTransfersLink').toUpperCase(),
            url: '/myprofile/transfers'
        }

        if (beneficiaryType === BENEFICIARY_TYPE_NGO)
            recordPath(window.location.pathname, 'proc-transferencia-solidaria', PROC_FAIL);
            const isImmediateTransfer =  immTransferState.get("doTransferImmediate");
            const serviceType = getServiceTypeValue(isImmediateTransfer);
        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8 transfer-view__left-first-box-full">
                <WizardError
                    errorMessage={errorTitle}
                    errorSubMessage={errorMessage}
                    mainButton={goBackButton}
                    tealium={{ serviceType }}
                    isSecondVersion
                />
            </div>
        )
    }
}

TransferViewErrors.propTypes = {
    errorMessage: PropTypes.string,
    immTransferState: PropTypes.object,
};

module.exports.constructor = TransferViewErrors;
module.exports.TransferViewErrors = connect(
    state => ({
        immTransferState: state.transfer,
    }),
)(TransferViewErrors);